import * as ActionType from '../constants/constant_action_types';

const INITIAL_STATE = {
  primary_subsidiary: {},
  company_primary_subsidiary: {},
};

export function subsidiaryReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionType.SET_PRIMARY_SUBSIDIARY: {
      return { ...state, primary_subsidiary: action.subsidiary };
    }

    case ActionType.SET_COMPANY_PRIMARY_SUBSIDIARY: {
      return { ...state, company_primary_subsidiary: action.subsidiary };
    }

    default:
      return state;
  }
}
